import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';
import { useDispatch } from 'react-redux';
import moment from 'moment';

const RMGSubcontractorList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const passedState = location.state;
    console.log("passedState:::", passedState);
    useEffect(() => {
        dispatch(updateNavbarHeading(passedState ? passedState?.text : "SubContractor List"))
    }, [passedState])
    const [subContractorListData, setSubContractorListData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [apiStatus, SetApiStatus] = useState(undefined)



    const columns = {
    Code: { text: "EMP ID", align: "left", width: "150px", visible: false },
    ClientName: { text: "Client Name", align: "left", width: "150px", visible: true },
    EmployeeName: {
      text: "Name",
      align: "left",
      width: "200px",
      visible: true,
    },
    Role: { text: "Role", align: "left", visible: true },
    SkillName: { text: "Skill", align: "start", visible: true },
    LocationName: { text: "Location", align: "start", visible: true },
    ProjectTypes: { text: "Project Type", align: "left", visible: false },
    ResCost: { text: "PO Cost", align: "end", visible: true },
    
    TotalExp: { text: "Exp.", align: "end", visible: false },
    Frequency: { text: "Frequency", align: "end", visible: false },
 
    StartDate: { text: "Start Date", align: "center", visible: false },
    ToDate: { text: "End Date", align: "center", visible: false },
  };


    useEffect(() => {
        fetchSubContractor();
    }, []);


    const fetchSubContractor = async () => {
        SetApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}report/11`)
            SetApiStatus(response?.status)
            if (response?.status == 200) {
                const cleanedData = response?.data?.data
                setSubContractorListData(cleanedData)
            }

        } catch (error) {
            console.error("Fetchinkg SubCOntrctor API Error ", error);

        }
    }


    console.log("originalData", originalData);

    useEffect(() => {
        if (originalData.length === 0) return;

        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get('Active');
        const name = queryParams.get('Name');
        const fromDate = queryParams.get('FromDate');
        const toDate = queryParams.get('ToDate');
        const RfromDate = queryParams.get('RfromDate');
        const RtoDate = queryParams.get('RtoDate');

        const filteredData = originalData.filter(item => {
            const joinDate = moment(item.JoiningDate);
            const reliveDate = moment(item.RelivingDate);

            const fromCondition = fromDate
                ? joinDate.isSameOrAfter(moment(fromDate), 'day')
                : true;

            const toCondition = toDate
                ? joinDate.isSameOrBefore(moment(toDate), 'day')
                : true;

            const RfromCondition = RfromDate
                ? reliveDate.isSameOrAfter(moment(RfromDate), 'day')
                : true;

            const RtoCondition = RtoDate
                ? reliveDate.isSameOrBefore(moment(RtoDate), 'day')
                : true;

            const Fstatus = status
                ? item.Active?.trim()?.toLowerCase() === status?.trim()?.toLowerCase()
                : true;

            const Fname = name == "Sub_Contractor"
                ? item.Name?.toLowerCase()?.startsWith(name?.toLowerCase())
                : name == "Employees" ? !item.Name?.toLowerCase()?.startsWith("sub_contractor") : true;

            return fromCondition && toCondition && RtoCondition && RfromCondition && Fstatus && Fname;
        });
        console.log("filteredData", filteredData);

        setSubContractorListData(filteredData);
    }, [location.search, originalData]);




    return (
        <div className="container-fluid" id="skill_section">
            <div className=" rounded bg-white" id="skill-table-area">
                <div className="row mt-2">
                    <Dynamic_PR_table
                        data={subContractorListData}
                        isActionRequired={false}
                        columns={columns}
                        itemsPerPage={8}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        showIcon1={false}
                        isSorting={false}
                        isApiStatus={apiStatus}
                        isRequiredStatus={true}
                        showIcon2={true}
                        showIcon3={false}
                        //   hanldeLinkColumn={hanldeLinkColumn}
                        //   handleBtn={() => handleApply()}
                        //   handleIconClick={handleJD}

                        //   handleIcon2={handleView}

                        icons={{
                            Icon1: <i class="bi bi-pencil-square"></i>,
                            Icon1Text: 'Edit',
                            Icon2: <i className="bi bi-eye-fill"></i>,
                            Icon2Text: 'View',
                            Icon3: <i className="bi bi-wallet2"></i>,
                            Icon3Text: 'Employee Payroll',
                        }}
                        isFilteredRequired={false}
                        isAddNewBtnRequired={false}
                    />

                </div>
            </div>
        </div>
    )
}

export default RMGSubcontractorList;